import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Icon from "@insite/mobius/Icon";
import Info from "@insite/mobius/Icons/Info";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

export interface MultipleSaleQtyStyles {
    wrapper?: InjectableCss;
}

export const multipleSaleQtyStyles: MultipleSaleQtyStyles = {
    wrapper: {
        css: css`
            color: black;
            font-size: 14px;
        `,
    },
};

const styles = multipleSaleQtyStyles;

interface OwnProps {
    multipleSaleQty: number;
}

type props = OwnProps & HasProductContext;

const MultipleSaleQtyComponent: React.FC<props> = ({
    multipleSaleQty,
    productContext: {
        product: { properties },
    },
}) => {
    const [discontinued, setDiscontinued] = React.useState(false);
    React.useEffect(() => {
        if (properties?.productDiscontinued === "true") {
            setDiscontinued(true);
        }
    }, []);
    return (
        <>
            {!discontinued && (
                <StyledWrapper className="multipleOrderQty" {...styles.wrapper}>
                    Must order in multiples of {multipleSaleQty}
                </StyledWrapper>
            )}
        </>
    );
};

export default withProductContext(MultipleSaleQtyComponent);
